import { render, staticRenderFns } from "./InfraRouter.vue?vue&type=template&id=6d5c2425&"
import script from "./InfraRouter.vue?vue&type=script&lang=js&"
export * from "./InfraRouter.vue?vue&type=script&lang=js&"
import style0 from "./InfraRouter.vue?vue&type=style&index=0&id=6d5c2425&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports